export function openHours() {
    // const today = moment().format('dddd');
    // const bankInfo = openHoursInfo[today];
    // const todayOpen = bankInfo[0].openTime;
    // const todayclose = bankInfo[0].closeTime;
    // const bankTimeZone = bankInfo[0].timeZone;
    // const statusBtn = $(".bank-status .button");
    //
    // function isOpen(openTime, closeTime, timezone) {
    // 	const now = moment.tz(timezone);
    // 	const date = now.format("YYYY-MM-DD");
    // 	const bankOpenTime = moment.tz(date + ' ' + openTime, "YYYY-MM-DD h:mmA", timezone);
    // 	const bankCloseTime = moment.tz(date + ' ' + closeTime, "YYYY-MM-DD h:mmA", timezone);
    //
    // 	let check;
    // 	if (bankCloseTime.isBefore(bankOpenTime)) {
    // 		check = now.isAfter(bankOpenTime) || now.isBefore(bankCloseTime);
    // 	} else {
    // 		check = now.isBetween(bankOpenTime, bankCloseTime, null, '[)');
    // 	}
    //
    // 	if (check) {
    // 		// statusBtn.text(Drupal.t('Open Now'));
    // 		statusBtn.text("Open Now");
    //
    // 	} else {
    // 		// statusBtn.text(Drupal.t('Close Now'));
    // 		statusBtn.text("Close Now");
    // 	}
    // }

    // isOpen(todayOpen, todayclose, bankTimeZone);
    $(".bank-status button").on("click", function (e) {
        e.preventDefault();
        let accordion = $(".location-details .accordion");
        let scrollTo = accordion.offset().top;
        let headerHeight = $(".header").innerHeight();

        if (!accordion.find(".accordion-item").first().find("details").attr("open")) {
            accordion.find(".accordion-item").first().find(".title").trigger("click");
        }

        $("html, body").animate({scrollTop: scrollTo - headerHeight}, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/openHours.js